

@for (item of tabData ; track item; let i = $index) {
  <div class="insured-card is-active pointer insure-tab-{{dataCategory}}">
    <div class="insured-card__title">
      <h5>{{item.policy_id}}</h5>
      <small>{{item.description_1}}</small>
    </div>
    <ul class="insured-card__items list-unstyled">
      <li class="insured-card__item">
        <small>Sum Insured</small>
        <p>R {{item.benefit_value}}</p>
      </li>
      <li class="insured-card__item">
        <small>Excess</small>
        <p>R {{item.item_excess}}</p>
      </li>
      <li class="insured-card__item">
        <small>Premium</small>
        <p><strong>R {{item.prem_value}}</strong>/mo</p>
      </li>
    </ul>
    <div class="insured-card__actions">
      <a href="#modal-policies-actions" class="dropdown-toggle dropdown-toggle--central dropdown-toggle--nocaret d-md-none" data-toggle="modal">
        <svg class="icon"><use xlink:href="#more"></use></svg>
      </a>
      <div class="dropdown d-none d-md-inline-block">
        <a href="#" class="dropdown-toggle dropdown-toggle--central dropdown-toggle--more d-none d-md-block" data-toggle="dropdown" aria-expanded="false">
          <svg class="icon"><use xlink:href="#more"></use></svg>
        </a>
        <a href="#modal-traymenu-actions" class="dropdown-toggle dropdown-toggle--central dropdown-toggle--nocaret d-md-none" data-toggle="modal">
          <svg class="icon"><use xlink:href="#more"></use></svg>
        </a>
        <div class="dropdown-menu dropdown-menu-right dropdown-menu--central">
          <a class="dropdown-item" data-sortby="best_value">
            <svg class="icon"><use xlink:href="#claims"></use></svg>
            <span>File Claim</span>
          </a>
          <a class="dropdown-item" data-sortby="best_value">
            <svg class="icon"><use xlink:href="#edit-underline"></use></svg>
            <span>Edit Item</span>
          </a>
          <!-- <a class="dropdown-item" data-sortby="best_value">
          <svg class="icon"><use xlink:href="#pause"></use></svg>
          <span>Pause Item</span>
        </a> -->
        <a class="dropdown-item" data-sortby="best_value">
          <svg class="icon"><use xlink:href="#trash-bin"></use></svg>
          <span>Cancel Item</span>
        </a>
      </div>
    </div>
  </div>
</div>
}